import React from "react";
import AvatarUsuarioLog from "../UI/AvatarUsuarioLog/AvatarUsuarioLog";
import Menu from "../UI/Menu/Menu";

const listItems = [
  {
    id: "logout",
    title: "Cerrar sesión",
  },
];

const MenuUsuario = (props) => {
  const onItemClick = (selectedItem) => {
    switch (selectedItem.id) {
      case "logout":
        return window.location.replace("/logout");

      default:
        break;
    }
  };

  return (
    <div style={{ cursor: "pointer" }}>
      <Menu
        placement={"bottom-end"}
        email={sessionStorage.getItem("userEmail")}
        title={<AvatarUsuarioLog />}
        listItems={listItems}
        onItemClick={(selectedItem) => onItemClick(selectedItem)}
      />
    </div>
  );
};

export default MenuUsuario;
